import {
  isMaturaCourseTopicVisible,
  MATURA_COURSE_STRUCTURE,
} from "./matura/maturaCourseStructure";

function slugify(value) {
  return String(value || "")
    .toLocaleLowerCase("pl")
    .replace(/[łŁ]/g, "l")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function topicSlug(topic) {
  const context = topic.groupTitle || "";
  const name = context ? `${context} ${topic.title}` : topic.title;
  return `zadania-maturalne-${slugify(name)}`;
}

const publicCourseTopics = MATURA_COURSE_STRUCTURE.flatMap((section) =>
  section.topics
    .filter((topic) => topic.taskTypes.length && isMaturaCourseTopicVisible(topic, "student"))
    .map((topic) => ({ ...topic, sectionTitle: section.title }))
);

export const maturaSeoTopicRegistry = publicCourseTopics.map((topic) => ({
  slug: topicSlug(topic),
  title: topic.title,
  seoKind: "matura-course",
  courseTopicCode: topic.code,
  sectionNo: topic.sectionNo,
  sectionTitle: topic.sectionTitle,
  topicName: topic.topicName,
  preparationLessonId: topic.preparationLessonId,
  hasPreparation: Boolean(topic.preparationLessonId),
  taskTypes: topic.taskTypes,
  sitemap: true,
  seoTitle: `${topic.title} – zadania maturalne, teoria i quiz | Matematron`,
  seoDescription: `Przygotuj zagadnienie „${topic.title}” do matury z matematyki. Skorzystaj z teorii, ćwiczeń maturalnych, wyjaśnień i quizu w uporządkowanej ścieżce Matematronu.`,
  seoNote: `Zagadnienie „${topic.title}” należy do działu „${topic.sectionTitle}” w ścieżce przygotowania do matury podstawowej.`,
}));

const slugByCourseCode = Object.fromEntries(
  maturaSeoTopicRegistry.map((topic) => [topic.courseTopicCode, topic.slug])
);

const LEGACY_TARGET_CODE = Object.freeze({
  "zadania-maturalne-liczby-i-dzialania-zamkniete": "1.1.5",
  "zadania-maturalne-algebra-zamkniete": "2.1.2",
  "zadania-maturalne-algebra-otwarte": "2.4.2",
  "zadania-maturalne-algebra-rozszerzenie": "2.2.3",
  "zadania-maturalne-funkcje-zamkniete": "3.1.2",
  "zadania-maturalne-funkcje-otwarte": "3.3.6",
  "zadania-maturalne-funkcje-rozszerzenie": "3.3.2",
  "zadania-maturalne-ciagi-zamkniete": "4.1.1",
  "zadania-maturalne-ciagi-otwarte": "4.3.5",
  "zadania-maturalne-trygonometria-zamkniete": "5.1.2",
  "zadania-maturalne-trygonometria-otwarte": "5.2.3",
  "zadania-maturalne-trygonometria-rozszerzenie": "5.2.3",
  "zadania-maturalne-planimetria-zamkniete": "6.1.9",
  "zadania-maturalne-planimetria-otwarte": "6.1.7",
  "zadania-maturalne-geometria-analityczna-zamkniete": "7.2.3",
  "zadania-maturalne-geometria-analityczna-otwarte": "7.1.2",
  "zadania-maturalne-stereometria-zamkniete": "8.3.1",
  "zadania-maturalne-stereometria-otwarte": "8.1.3",
  "zadania-maturalne-prawdopodobienstwo-i-statystyka-zamkniete": "9.2.1",
  "zadania-maturalne-prawdopodobienstwo-i-statystyka-otwarte": "9.3.2",
  "zadania-maturalne-prawdopodobienstwo-i-statystyka-rozszerzenie": "9.1.1",
  "zadania-maturalne-dowody-matematyczne-otwarte": "10.1.1",
});

export const legacyMaturaSeoRedirects = Object.entries(LEGACY_TARGET_CODE)
  .map(([fromSlug, courseTopicCode]) => ({
    fromSlug,
    toSlug: slugByCourseCode[courseTopicCode],
    courseTopicCode,
  }))
  .filter((redirect) => Boolean(redirect.toSlug));
